const slider = [
  {
    name: "Foundation",
    detail: "For schools seeking a clear starting point.",
    content: "Foundation is designed for schools that want practical staff training, clearer priorities and focused next steps. It begins with an on site consultation and discovery day, followed by tailored preparation and staff training.",
    desc1: "* On-site consultation and discovery",
    desc2: "* Tailored preparation - Staff training",
    desc3: "* Staff training, Priority action summary",
    desc4: "* Follow up leadership call",
  },
  {
    name: "Strengthen",
    detail: "For schools ready to improve systems and staff confidence.",
    content : "Strengthen supports schools that have policies in place but want greater consistency in reporting, leadership clarity, staff confidence and day to day implementation.",
    desc1: "* On site consultation and discovery",
    desc2: "* Document and systems review",
    desc3: "* Full day staff training",
    desc4: "* Leadership or DSL strategy session",
    desc5: "* Written improvement roadmap",
    desc6: "* Follow up review meeting",
  },
  {
    name: "Embed",
    detail: "For schools seeking sustained improvement.",
    content: "Embed is designed for schools that want deeper support to strengthen safeguarding culture, systems and staff practice over time. It combines consultation, audit, staff development, leadership support and implementation planning.",
    desc1: "* On site consultation and discovery",
    desc2: "* Safeguarding and culture audit",
    desc3: "* Staff training and leadership development",
    desc4: "* Systems and implementation support",
    desc5: "* Final impact and sustainability report",
    desc6: "* Ongoing implementation meetings",
  },
];
export default slider;